export default __webpack_public_path__ + "static/dummyWithBg-fc9b3258068b66c05d14c58d29b4a42b.png";